import { Component, OnInit } from '@angular/core';

import { LayoutBtnFloatingComponent } from '../shared/components/layout-btn-floating/layout-btn-floating.component';
import { LayoutFooterComponent } from '../shared/components/layout-footer/layout-footer.component';
import { LayoutNavbarMenuComponent } from '../shared/components/layout-navbar-menu/layout-navbar-menu.component';
import { LayoutSidebarMenuComponent } from '../shared/components/layout-sidebar-menu/layout-sidebar-menu.component';
import { SessionService } from '../shared/services/session.service';

@Component({
  selector: 'app-office',
  templateUrl: './office.component.html',
  styleUrls: ['./office.component.css']
})
export class OfficeComponent implements OnInit {

  showBtnFloating : boolean;

  constructor(
    private _sessionService : SessionService
  ) { }

  ngOnInit() { 
    /*this.showBtnFloating = false;
    let _contratos = this._sessionService.getContracts();
    if(_contratos !== undefined && _contratos !== null){
      this.showBtnFloating = true;
    }*/
  } 

}



// WEBPACK FOOTER //
// /app/src/app/office/office.component.ts